export class FirmUserTransformer {
    static transform(obj) {
      let firmUser = {};
      firmUser.id = obj.id;
      firmUser.firmId = obj.attributes.firm_id;
      firmUser.userId = obj.attributes.person_id;
      return firmUser;
    }
  }
  


// WEBPACK FOOTER //
// ./src/helpers/firmUsers/firmUser.transformer.js